import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, NgForm, FormControl, Validators } from '@angular/forms';
import { CedenteGestorCadastro } from 'src/app/models/cedentegestor-cadastro';
import { GestorService } from 'src/app/services/gestor.service';
import { Router, ActivatedRoute } from '@angular/router';
import { CedenteCadastro } from 'src/app/models/cedente-cadastro';
import { MASKS, NgBrazilValidators } from 'ng-brazil';
import { GestorCadastro } from 'src/app/models/gestor-cadastro';
import { CedenteService } from 'src/app/services/cedente.service';
import { PerfilNormalizado } from 'src/app/shared/enums/perfil-normalizado.enum';
import { Termo } from 'src/app/shared/enums/termo.enum';
import { number } from 'ng-brazil/number/validator';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { RegisterService } from 'src/app/services/register.service';
import { CompanyService } from 'src/app/services/companhia.service';

import { ApiError } from 'src/app/shared/enums/api-error.enum';
import { TermoUso } from 'src/app/models/termo-uso';
import { TermoUsoService } from 'src/app/services/termo-uso.service';
import { NewAlertService } from 'src/app/shared/components/new-alert/new-alert.service';
import { ReceitaWsResponse } from 'src/app/models/companhia';

@Component({
    selector: 'app-register-cedente',
    templateUrl: './register-cedente.component.html',
    styleUrls: ['./register-cedente.component.css']
})
export class RegisterCedenteComponent implements OnInit {

    public get form() {
        return this.cedenteGestorCadastroFormGroup.controls;
    }

    public get formCedenteCadastro() {
        return this.cedenteGestorCadastroFormGroup.controls.cedenteCadastro;
    }

    private gestorCadastro: GestorCadastro;
    public cedenteGestorCadastroFormGroup: FormGroup;
    private cedenteGestorCadastro: CedenteGestorCadastro;
    public termoUsoContaCorrente: TermoUso;
    public inDocumento: string;
    public empresa: ReceitaWsResponse;

    public MASKS = MASKS;    
    public cnpjValido = false;
    public termoAceito = false;

    constructor(
        private formBuilder: FormBuilder, 
        private gestorService: GestorService, 
        private cedenteService: CedenteService,
        private router: Router, 
        private route: ActivatedRoute, 
        private modalService: NgbModal, 
        private registerService: RegisterService,
        private alertService: NewAlertService, 
        private companyService: CompanyService,
        private termoUsoService: TermoUsoService) {
    }

    ngOnInit() {
        this.registerService.currentCadastro.subscribe(
            response => {
                if (response === null) {
                    this.router.navigate(['']);
                }
                this.cedenteGestorCadastro = response;
                this.cedenteGestorCadastro.perfilNomeNormalizado = PerfilNormalizado.Responsavel;
                this.gestorCadastro = this.cedenteGestorCadastro.gestorCadastro;
                this.cedenteGestorCadastro.cedenteCadastro = new CedenteCadastro('', '', '', '', '', 
                    this.gestorCadastro.email, this.gestorCadastro.emailConfirmacao, this.gestorCadastro.senha, this.gestorCadastro.senhaConfirmacao, '', '');

                this.createForm(this.cedenteGestorCadastro);
            }
        );

        this.termoUsoService.getTermoUsoContaCorrente().subscribe(
            rs => {
                if (rs.status === ApiError.Sucesso) {
                    this.termoUsoContaCorrente = rs.result;
                } else {
                    this.alertService.error(rs.message);
                }
            }
        );

    }

    public telefoneCelularMask = (telefone: any) => {
        telefone = telefone.replace(/\D+/g, '').replace(' ', '');
        if (telefone.length <= 10) {
            return ['(',/\d/,/\d/,')',' ',/\d/,/\d/,/\d/,/\d/,'-',/\d/,/\d/,/\d/,/\d/];
        } else if (telefone.length > 10) {
            return ['(',/\d/,/\d/,')',' ',/\d/,/\d/,/\d/,/\d/,/\d/,'-',/\d/,/\d/,/\d/,/\d/];
        }
    }

    showTermo(content) {
        this.modalService.open(content, { centered: true, size: 'lg' });
    }

    acceptTermo() {
        this.form.termoAceito.setValue(true);
        this.termoAceito = true;
    }

    refuseTermo() {
        this.form.termoAceito.setValue(false);
        this.termoAceito = false;
    }

    createForm(cedenteGestorCadastro: CedenteGestorCadastro) {
        this.cedenteGestorCadastroFormGroup = this.formBuilder.group({
            cedenteCadastro: new FormGroup({
                cnpj: new FormControl(cedenteGestorCadastro.cedenteCadastro.cnpj, [
                    Validators.required,
                    NgBrazilValidators.cnpj
                ]),
                nomeFantasia: new FormControl(cedenteGestorCadastro.cedenteCadastro.nomeFantasia, [
                    Validators.required,
                    Validators.minLength(3),
                    Validators.maxLength(200)
                ]),
                razaoSocial: new FormControl(cedenteGestorCadastro.cedenteCadastro.razaoSocial, [
                    Validators.required,
                    Validators.minLength(3),
                    Validators.maxLength(150)
                ]),
                inscricaoEstadual: new FormControl(cedenteGestorCadastro.cedenteCadastro.inscricaoEstadual, []),
                inscricaoMunicipal: new FormControl(cedenteGestorCadastro.cedenteCadastro.inscricaoMunicipal, []),
                telefoneNumero: new FormControl(cedenteGestorCadastro.cedenteCadastro.telefoneNumero, [
                    Validators.required,
                    NgBrazilValidators.telefone
                ]),
                email: new FormControl(cedenteGestorCadastro.cedenteCadastro.email, [
                    Validators.required
                ]),
                senha: new FormControl(cedenteGestorCadastro.cedenteCadastro.senha, [
                    Validators.required
                ]),
                emailConfirmacao: new FormControl(cedenteGestorCadastro.cedenteCadastro.email, [
                    Validators.required
                ]),
                senhaConfirmacao: new FormControl(cedenteGestorCadastro.cedenteCadastro.senha, [
                    Validators.required
                ])
            }),
            perfilNomeNormalizado: new FormControl(cedenteGestorCadastro.perfilNomeNormalizado, [
                Validators.required
            ]),
            termoAceito: new FormControl(this.termoAceito, [
                Validators.required
            ])
        });
    }

    public CompleteWithZero(cnpj: string) {
        if (!this.inDocumento) { return; }

        const inputValue = this.inDocumento.replace(/\D+/g, '').replace(' ', '');
        let zeros = '';

        for (let i = 0; i < 14 - inputValue.length; i++) { zeros += '0'; }

        this.inDocumento = this.formataCNPJ(zeros + inputValue);

        cnpj = this.inDocumento
        this.getDados(cnpj);
    }

    formataCNPJ(cnpj) {
        return cnpj.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
    }

    onSubmit(cedenteGestorCadastro: CedenteGestorCadastro) {
        if (this.cedenteGestorCadastroFormGroup.valid) {
            cedenteGestorCadastro.cedenteCadastro.cnpj = cedenteGestorCadastro.cedenteCadastro.cnpj.replace(/\D+/g, '').replace(' ', '');
            cedenteGestorCadastro.gestorCadastro = this.gestorCadastro;
            let dataNascimentoRaw = cedenteGestorCadastro.gestorCadastro.dataNascimento;
            dataNascimentoRaw = { dataNascimentoRaw };
            cedenteGestorCadastro.gestorCadastro.dataNascimento = this.gestorCadastro.dataNascimento;
            cedenteGestorCadastro.cedenteCadastro.telefoneNumero = cedenteGestorCadastro.cedenteCadastro.telefoneNumero.replace(/\D+/g, '').replace(' ', '');

            // verificar se o candidato a gestor(CPF) pode ser o gestor caso o candidado a cedente(CNPJ) já for um estabelecimento
            this.gestorService.getGestorCedenteElegibility(this.gestorCadastro.cpf, cedenteGestorCadastro.cedenteCadastro.cnpj).subscribe(
                responseGestor => {
                    if (responseGestor.result) {
                        // gravar cedente + associação
                        this.cedenteService.add(cedenteGestorCadastro).subscribe(
                            responseCedente => {
                                if (responseCedente.status === ApiError.Sucesso) {
                                    this.router.navigate(['end'], { relativeTo: this.route.parent });
                                } else {
                                    this.alertService.error(responseCedente.message);
                                    cedenteGestorCadastro.gestorCadastro.dataNascimento = dataNascimentoRaw.dataNascimentoRaw;
                                }
                            },
                            error => {
                                this.alertService.error('Ocorreu um erro ao tentar processar a solicitação!');
                                cedenteGestorCadastro.gestorCadastro.dataNascimento = dataNascimentoRaw.dataNascimentoRaw;
                            }
                        );
                    } else {
                        this.alertService.error('Cadastro inválido. Cedente já cadastrada.');
                        cedenteGestorCadastro.gestorCadastro.dataNascimento = dataNascimentoRaw.dataNascimentoRaw;
                    }
                },
                error => {
                    this.alertService.error('Ocorreu um erro ao tentar processar a solicitação!');
                    cedenteGestorCadastro.gestorCadastro.dataNascimento = dataNascimentoRaw.dataNascimentoRaw;
                }
            );
        }
    }
    
    getDados(cnpj: string) {
        cnpj = cnpj.replace(/\./g, '').replace(/\-/g, '').replace(/\//g, '').trim();

        this.formCedenteCadastro.patchValue({
            nomeFantasia: null,
            razaoSocial: null
        });

        this.companyService.getDetalhesEmpresa(cnpj).subscribe(
            response => {
                this.empresa = response.result;
                this.setDados(this.empresa);

            }, error => {
                this.alertService.error('Não foi possivel realizar a busca do cnpj');
            }
        );

    }

    setDados(empresa?: ReceitaWsResponse) {
        if (empresa) {                  

            if(empresa.fantasyName == ""){
                empresa.fantasyName = empresa.name
            }

            this.formCedenteCadastro.patchValue({
                nomeFantasia: empresa.fantasyName,
                razaoSocial: empresa.name
            });
            
            if(!empresa.isRegistered || empresa.isPreRegistered){
                this.cnpjValido = true
            } else {
                this.alertService.error('Cedente já possui cadastro');
            }
        } else {
            this.cnpjValido = false
            this.alertService.error('CNPJ não encontrado na base a receita federal');
        }

    }

}
